import { forwardRef } from 'react';
import type { WallpaperConfig } from '../config/schema';
import { LifeGrid } from '../modes/LifeGrid';
import { YearlyGrid } from '../modes/YearlyGrid';
import { MonthlyGrid } from '../modes/MonthlyGrid';

interface Props {
  config: WallpaperConfig;
  today: Date;
}

export const Wallpaper = forwardRef<SVGSVGElement, Props>(({ config, today }, ref) => {
  const { device, colors, showTitle, title, padding } = config;
  const titleSize = Math.max(40, Math.min(device.width, device.height) * 0.045);
  const titleHeight = showTitle ? titleSize * 2.2 : 0;

  let body;
  switch (config.mode) {
    case 'life':
      body = <LifeGrid config={config} today={today} titleHeight={titleHeight} />;
      break;
    case 'yearly':
      body = <YearlyGrid config={config} today={today} titleHeight={titleHeight} />;
      break;
    case 'monthly':
      body = <MonthlyGrid config={config} today={today} titleHeight={titleHeight} />;
      break;
  }

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${device.width} ${device.height}`}
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid meet"
      data-mode={config.mode}
    >
      <rect x={0} y={0} width={device.width} height={device.height} fill={colors.background} />
      {showTitle && title && (
        <text
          x={device.width / 2}
          y={padding.vertical + titleSize}
          fill={colors.text}
          fontFamily="'EB Garamond', ui-serif, Georgia, serif"
          fontWeight={500}
          fontSize={titleSize}
          textAnchor="middle"
          letterSpacing={titleSize * 0.04}
        >
          {title}
        </text>
      )}
      {body}
    </svg>
  );
});
Wallpaper.displayName = 'Wallpaper';
